// src/pages/About.js
import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-container">
      
      <p>
        Gigabout Australia is a platform to bring fans, music artists, and venues together.
        The platform is currently operational and features and bug fixes will be updated regularly. Please feel free to register.
      </p>
    </div>
  );
}

export default About;
